<template>
  <nx-bform @submit="onSubmit" class="reset-password-form">
    <h5>{{ $t(heading) }}</h5>

    <nx-bform-server-errors />

    <LoginPasswordNewFormGroup
      v-model="form.newPassword"
      label-cols="2"
      label-align="right"
      required
    />

    <LoginPasswordFormGroup
      :label="$t('form.verify')"
      v-model="form.verifyPassword"
      label-cols="2"
      label-align="right"
      required
    />

    <b-form-group label-cols="2">
      <b-button type="submit" class="bd-button">{{ $t("confirm") }}</b-button>
    </b-form-group>
  </nx-bform>
</template>

<script>
import { UserApi } from "nx-libs";
import LoginPasswordFormGroup from "@/forms/login/LoginPasswordFormGroup";
import LoginPasswordNewFormGroup from "@/forms/login/LoginPasswordNewFormGroup";
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  components: {
    LoginPasswordFormGroup,
    LoginPasswordNewFormGroup
  },
  props: {
    targetUrl: {
      type: String,
      default: "%2Fpublic%2F%23%2Fsignin"
    },
    activationKey: {
      type: String,
      default: ""
    },
    newUser: {
      type: String,
      default: "false"
    }
  },
  data() {
    return {
      form: {
        newPassword: "",
        verifyPassword: ""
      }
    };
  },
  computed: {
    heading() {
      if (this.newUser === "true") {
        return "heading-new";
      } else {
        return "heading";
      }
    }
  },
  methods: {
    async onSubmit() {
      try{
        const { targetUrl, activationKey } = this;
        const { newPassword, verifyPassword } = this.form;

        if (newPassword !== verifyPassword) {
          this.$dangerToast(this.$t("error"), this.$t("msg.pwMismatched"));
          return;
        }


        await UserApi.resetPassword({
          oldPwd: "",
          activationKey,
          newPwd1: newPassword,
          newPwd2: verifyPassword
        });

        this.$successToast(this.$t("success"), this.$t("msg.pwChanged"));

        setTimeout(() => (window.location.href = targetUrl), 2000);
      }
      catch ({response}) {
        if (response&&response.data) {
          console.log("response",response.data);
          // const errorCode = response.data.split(/\s?:\s?/)[0];
          // const errorMessage = response.data.split(/\s?:\s?/)[1];
          // console.log("errorCode",errorCode);
          // console.log("errorMessage",errorMessage);
          // var errorMsg="";
          // if (response.data.split(/\s?:\s?/).length==1) {
          //   errorMsg = response.data;
          //   console.log("errorMsg",errorMsg);
          // }       
          // else errorMsg = this.$t(errorCode);
          // console.log("errorMsg2",errorMsg);

          this.$dangerToast("Error", translateResponseError(this, response.data));
        }
      }
    
    }
  }
};
</script>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/msg.locale"></i18n>
<i18n src="@/locales/responseMsg.locale"></i18n>
<i18n>
{
  "en": {
    "heading":"Reset Password",
    "heading-new":"Set Password",
    "form":{
      "verify":"Verify new password"
    },
    "msg": {
      "pwMismatched": "New password mismatched",
      "pwChanged": "Password changed. Redirecting to login..."
    }
  },
  "zh_hk": {
    "heading":"重置密碼",
    "heading-new":"設置密碼",
    "form":{
      "verify":"確認新密碼"
    },
    "msg": {
      "pwMismatched": "新密碼不匹配",
      "pwChanged": "密碼已更改。重定向到登錄..."
    }
  },
  "zh_cn": {
    "heading":"重置密码",
    "heading-new":"设置密码",
    "form":{
      "verify":"确认新密码"
    },
    "msg": {
      "pwMismatched": "新密码不匹配",
      "pwChanged": "密码已更改。重定向到登录..."
    }
  }
}
</i18n>
